module.exports = __webpack_public_path__ + "img/accenta.b1253a11.jpg";